module.exports = __webpack_public_path__ + "static/media/why_zh_tw.eb9b0ce8.vtt";